import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewLocation from "../../../../components/@locations/locations/NewLocation";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function LocationNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewLocation
                routeType={routeType}
            />
        </SettingFrame>
    )
}